import { Link } from "react-router";
import { invoiceTotals, useInvoices, useMarkPaid } from "../../api/invoices.js";
import { AppShell } from "../../components/AppShell.js";
import { EmptyState } from "../../components/EmptyState.js";
import { Skeleton } from "../../components/Skeleton.js";
import { formatDateTime, formatMoney } from "../../lib/format.js";

export function SupplierInvoicesPage() {
  const { data, isPending } = useInvoices("supplier");
  const markPaid = useMarkPaid();
  const totals = data ? invoiceTotals(data) : null;

  return (
    <AppShell title="발행한 청구서">
      {totals ? (
        <p className="mb-4 rounded-xl bg-stone-100 p-4">
          전체 {totals.count}건 · 미수금 <strong>{formatMoney(totals.unpaidTotal)}</strong>
        </p>
      ) : null}
      {isPending ? <Skeleton /> : null}
      {data && data.length === 0 ? <EmptyState message="아직 발행한 청구서가 없습니다." /> : null}
      <ul>
        {data?.map((invoice) => (
          <li key={invoice.id} className="border-b border-stone-200 py-3">
            <div className="flex items-center justify-between">
              <Link to={`/invoices/${invoice.id}/print?scope=supplier`}>
                <span className="font-medium">{invoice.restaurant.name}</span>
                <span className="ml-2 text-sm text-stone-500">
                  {invoice.number} · {formatDateTime(invoice.issuedAt)}
                </span>
              </Link>
              <span className="font-semibold">{formatMoney(invoice.total)}</span>
            </div>
            <button
              type="button"
              className="mt-2 rounded-lg border border-stone-300 px-3 py-2 text-sm disabled:opacity-50"
              disabled={markPaid.isPending}
              onClick={() => markPaid.mutate({ id: invoice.id, paid: invoice.paidAt === null })}
            >
              {invoice.paidAt ? "수금 완료 취소" : "수금 완료로 표시"}
            </button>
          </li>
        ))}
      </ul>
    </AppShell>
  );
}
